import { Theme } from '@salecycle/ui-component-library';
import { State as CampaignState } from '../../../../entities/lifecycle/lifeCycle';

export const getStatusColor = (campaignState: CampaignState, theme: Theme) => {
  switch (campaignState) {
    case 'ACTIVE':
      return theme.vars.newColor.green2;
    case 'TESTING':
      return theme.vars.newColor.orange2;
    case 'MIGRATION':
      return theme.vars.newColor.blue1;
    case 'INACTIVE':
      return theme.vars.newColor.lightGS1;
    case 'DELETED':
      return theme.vars.newColor.darkGS2;
    case 'SCHEDULED':
      return theme.vars.newColor.blue3;
    case 'FINISHED':
      return theme.vars.newColor.purple2;
    default:
      return null;
  }
};
